import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import SearchInput from '/components/searchInput';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('sm')]: {
        width: 900,
    },
    [theme.breakpoints.only('sm')]: {
        width: 650,
        padding: '0px 20px'
    },
    [theme.breakpoints.only('xs')]: {
        padding: '0px 20px'
    },
  },
  overrideInput: {
    margin: 0
  }  
});



class ResultNotFound extends Component {
  render() {

    const { classes } = this.props;

    return (
        <div className={classes.layout}>
            <Grid container spacing={24}>
              <Grid item xs={12} >
                <Typography gutterBottom style={{color: '#f35c51', marginBottom: 7}} variant="h6">
                  Sorry, no content matched your search. Please try again.
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <Typography gutterBottom variant="body1" style={{fontWeight: 'bold'}}>
                  Search Suggestings:
                </Typography>
                <ul>
                  <li>Check your spelling.</li>
                  <li>Try more general words.</li>
                  <li>Try different words that have the same meaning.</li>
                </ul>
              </Grid>
          </Grid>
        </div>
    );
  }
}
ResultNotFound.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ResultNotFound)
